import { render, staticRenderFns } from "./newsPage04.vue?vue&type=template&id=00dc70f1&scoped=true&"
import script from "./newsPage04.vue?vue&type=script&lang=js&"
export * from "./newsPage04.vue?vue&type=script&lang=js&"
import style0 from "./newsPage04.vue?vue&type=style&index=0&id=00dc70f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dc70f1",
  null
  
)

export default component.exports